import { Viewer } from './AprysePDF.styled'

interface Props {
  viewerRef: React.RefObject<HTMLDivElement>
  hideBorder?: boolean
}

export const AprysePDF: React.FC<Props> = ({ viewerRef, hideBorder }: Props) => {
  return <Viewer className="webviewer" ref={viewerRef} hideBorder={hideBorder} />
}
